import ComingSoon from "@/components/ComingSoon";

export default function ScriptsPage() {
  return <ComingSoon featureName="Scripts & Configurations" description="Create and deploy custom scripts and configurations. This feature requires backend Scripts/Configurations APIs." />;
}
